
import PlanesEsport from "../components/PlanesEsport";
import Bloque02 from "../components/Bloque02";

import styles from "../styles/esport.module.css";
import { Link } from "react-router-dom";

function Esport() {
    return (
        <main>
            <section className={styles.esportSection}>

                <Bloque02
                    imagen=""
                    titulo1="GLOBAL"
                    titulo2="ESPORT"
                    tipo="esport"
                    descripcion={
                        <>
                            En <strong> Global Esport</strong> no solo entrenamos cuerpos, también acompañamos sueños. Creemos en el poder del movimiento para transformar vidas, por eso diseñamos programas personalizados que se adaptan a ti, a tu historia y a tus metas. Ya seas atleta, aficionado o simplemente alguien que quiere superarse, estamos aquí para ayudarte a descubrir tu mejor versión, con compromiso, ciencia y pasión por el deporte.
                        </>
                    }
                />

                <PlanesEsport></PlanesEsport> 

                <Bloque02
                    imagen="assets/imagen1_bloque03.jpg"
                    titulo1="GLOBAL"
                    titulo2="ESPORT"
                    tipo="esport"
                    descripcion={
                        <>
                            En el área deportiva de Global nos enfocamos en potenciar el rendimiento físico y la recuperación de lesiones en deportistas de todos los niveles. Ofrecemos programas personalizados de <strong>readaptación deportiva</strong>, <strong>prevención de lesiones</strong> y <strong>mejora del rendimiento</strong>, combinando fisioterapia avanzada, entrenamiento funcional y técnicas de movilidad.<br /><br />

                            Nuestro equipo diseña planes específicos que incluyen <strong>fortalecimiento muscular</strong>, <strong>mejora de la biomecánica</strong> y ejercicios correctivos para optimizar cada movimiento y reducir el riesgo de recaídas. Además, proporcionamos asesoramiento en <strong>nutrición deportiva</strong> para apoyar la recuperación y maximizar el rendimiento en competición o entrenamientos exigentes.
                        </>
                    }
                />
                


                <div className={styles.grid}>

                    <div className={styles.card}>
                        <h3>Readaptación Deportiva</h3>
                        <ul>
                            <li>Planes de recuperación post-lesión</li>
                            <li>Prevención de recaídas</li>
                            <li>Reeducación funcional y movilidad</li>
                            <li>Progresión hacia la actividad deportiva</li>
                        </ul>
                    </div>

                    <div className={styles.card}>
                        <h3>Mejora del Rendimiento</h3>
                        <ul>
                            <li>Entrenamiento funcional específico</li>
                            <li>Optimización de fuerza y resistencia</li>
                            <li>Trabajo de velocidad y agilidad</li>
                            <li>Corrección de patrones de movimiento</li>
                        </ul>
                    </div>

                    <div className={styles.card}>
                        <h3>Biomecánica y Técnica</h3>
                        <ul>
                            <li>Análisis de la técnica deportiva</li>
                            <li>Mejora de la eficiencia en el movimiento</li>
                            <li>Prevención de sobrecargas</li>
                            <li>Asesoramiento postural avanzado</li>
                        </ul>
                    </div>
                    <div className={styles.card}>
                        <h3>Biomecánica y Técnica</h3>
                        <ul>
                            <li>Análisis de la técnica deportiva</li>
                            <li>Mejora de la eficiencia en el movimiento</li>
                            <li>Prevención de sobrecargas</li>
                            <li>Asesoramiento postural avanzado</li>
                        </ul>
                    </div>
                </div>

                



         


               
                
            </section>





        </main>
    );
}

export default Esport;